var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Form',{attrs:{"data":_vm.worker,"isSubmitting":_vm.isSubmitting,"isPCUploadVisible":false},on:{"submit":_vm.update}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }